import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { authRoutes } from './features/auth/auth.routes';
import { kioskRoutes } from './features/kiosk/kiosk.routes';
import { logsRoutes } from './features/logs/logs.routes';
import { usersRoutes } from './features/users/users.routes';
import { itemsRoutes } from './features/items/items.routes';
import { devicesRoutes } from './features/devices/devices.routes';
import { reportsRoutes } from './features/reports/reports.routes';
import { supportRoutes } from './features/support/support.routes';
import { settingsRoutes } from './features/settings/settings.routes';
import { baseJobsRoutes } from './features/base-jobs/base-jobs.routes';
import { warehousesRoutes } from './features/warehouses/warehouses.routes';
import { requisitionsRoutes } from './features/requisitions/requisitions.routes';
import { errorPagesRoutes } from './shared/pages/error-pages/error-pages.routes';
import { MainLayoutComponent } from './shared/layouts/main/main-layout.component';
import { SupportLayoutComponent } from './shared/layouts/support/support-layout.component';
import { jonasExportFilesRoutes } from './features/jonas-export-files/jonas-export-files.routes';

export const routes: Routes = [
	...authRoutes,
	...kioskRoutes,
	{
		path: 'support',
		component: SupportLayoutComponent,
		canActivate: [authGuard],
		children: [...supportRoutes]
	},
	{
		path: '',
		component: MainLayoutComponent,
		canActivate: [authGuard],
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'requisitions' },
			...usersRoutes,
			...devicesRoutes,
			...itemsRoutes,
			...requisitionsRoutes,
			...reportsRoutes,
			...logsRoutes,
			...settingsRoutes,
			...warehousesRoutes,
			...baseJobsRoutes,
			...jonasExportFilesRoutes
		]
	},
	...errorPagesRoutes
];
